import React from 'react';

const Faq = () => {
    return (
        <section>
            <div className="stg-row stg-bottom-gap-l">
                <div className="stg-col-8 stg-offset-2">
                    <div className="align-center">
                        <h2 data-split-appear="fade-up" data-unload="fade-up">Do you still have questions?</h2>
                        <p className="infocolors-large-text" data-appear="fade-up" data-delay="100" data-unload="fade-up">Here are some of the burning questions we hear most:</p>
                    </div>
                </div>
            </div>
            <div className="infocolors-faq-list">
                <div className="infocolors-toggles-item infocolors-block" data-appear="fade-up" data-unload="fade-up">
                    <div className="infocolors-toggles-item--title">
                        <span className="infocolors-label">General</span>
                        <h4>
                            <sup>01.</sup>
                            What exactly does infocolors do?
                        </h4>
                    </div>
                    <div className="infocolors-toggles-item--content">
                        <p>We're your brand's fairy godmothers (and fathers!) of transformation. We don't just design logos and write taglines; we craft your entire brand identity, from story to visuals. Think of us as storytellers, magicians, and digital alchemists, ready to ignite your brand and set it ablaze with passion and impact.</p>
                    </div>
                </div>
                <div className="infocolors-toggles-item infocolors-block" data-appear="fade-up" data-unload="fade-up">
                    <div className="infocolors-toggles-item--title">
                        <span className="infocolors-label">General</span>
                        <h4>
                            <sup>02.</sup>
                            I have a small business; is infocolors right for me?
                        </h4>
                    </div>
                    <div className="infocolors-toggles-item--content">
                        <p>Absolutely! We believe every brand, big or small, deserves to shine. We tailor our services to fit your unique needs and budget, ensuring you get the spark you need to stand out in your industry.</p>
                    </div>
                </div>
                <div className="infocolors-toggles-item infocolors-block" data-appear="fade-up" data-unload="fade-up">
                    <div className="infocolors-toggles-item--title">
                        <span className="infocolors-label">General</span>
                        <h4>
                            <sup>03.</sup>
                            What kind of results can I expect from working with infocolors?
                        </h4>
                    </div>
                    <div className="infocolors-toggles-item--content">
                        <span className="infocolors-highlight">We empower brands to:</span>
                        <ul className="infocolors-marked-list">
                            <li>Increase brand awareness and recognition.</li>
                            <li>Attract and engage their ideal target audience.</li>
                            <li>Build trust and loyalty with customers.</li>
                            <li>Improve lead generation and sales.</li>
                            <li>Stand out from the competition and become industry leaders.</li>
                            <li>Q: Do you offer ongoing support after the project is finished?</li>
                        </ul>
                    </div>
                </div>
                <div className="infocolors-toggles-item infocolors-block" data-appear="fade-up" data-unload="fade-up">
                    <div className="infocolors-toggles-item--title">
                        <span className="infocolors-label">General</span>
                        <h4>
                            <sup>04.</sup>
                            Do you offer ongoing support after the project is finished?
                        </h4>
                    </div>
                    <div className="infocolors-toggles-item--content">
                        <p>We become your brand partners, not just your project partners! We offer ongoing support and guidance to ensure your brand continues to thrive. This can include website maintenance, content creation, marketing campaign guidance, and even brand refreshers down the line. We're always there to keep your brand's fire burning bright.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Faq;
